<template>
	<div class="content_box flex-b" style="padding: 0 30px 30px;">
		<div class="details_left">
			<div class="flex-b">
				<img src="../assets/guoguologo.png" style="width: 180px;height: 50px;margin: 10px 0;">
				<!-- <div class="search_box flex-b">
					<el-input v-model="title" placeholder="请输入内容" :border="false" style="border: none;height: 40px;width: calc(100% - 80px);"></el-input>
					<div class="flex-a" style="width: 60px;cursor: pointer;" @click="bindsearch(1)" >
						<img src="../assets/sousuo.png" style="width: 14px;height: 14px;margin-right: 8px;" alt="">
						<div style="color: #333;font-size: 14px;">搜索</div>
					</div>
				</div> -->
			</div>
			<div>
				<div style="height: 610px;background-color: #333;border-radius: 10px;">
					<!-- <video controls v-if="videosrc" style="width: 100%;height: 810px;" >
					  <source :src="videosrc" type="video/mp4">
					  Download the
					  <a href="/media/cc0-videos/flower.mp4">MP4</a>
					  video.
					</video> -->
					<video ref="videoPlayer" v-if="videosrc" autoplay loop muted controls :src="videosrc"  style="width: 100%;height: 610px;border-radius: 20px;"></video>
				</div>
				<div class="text_box">
					<div class="text_title">
						<!-- <div>{{details.title}}</div> -->
						<div v-html="details.title"></div>
						<!-- <rich-text v-if="details.title" :nodes="details.title"></rich-text> -->
						<!-- <el-icon @click="detailsshow = !detailsshow" :style="detailsshow?'transform: rotate(180deg)':''" name="arrow-down-fill" color="#888888" size="16"></el-icon> -->
						<i class="el-icon-caret-bottom" @click="detailsshow = !detailsshow" :style="detailsshow?'transform: rotate(180deg)':''" color="#888888" size="16"></i>
					</div>
					<div class="text_t1">果果视频·电影</div>
					<div class="text_list" v-if="detailsshow">
						<div class="text_item">
							<div class="text_name">主演：</div>
							<div class="text_info">{{details.actor}}</div>
						</div>
						<div class="text_item">
							<div class="text_name">导演：</div>
							<div class="text_info">{{details.director}}</div>
						</div>
						<div class="text_item">
							<div class="text_name">语言：</div>
							<div class="text_info">{{details.language}}</div>
						</div>
						<!-- <div class="text_item">
							<div class="text_name">国别：</div>
							<div class="text_info">安吉斯/李健</div>
						</div> -->
						<!-- <div class="text_item">
							<div class="text_name">更新：</div>
							<div class="text_info">安吉斯/李健</div>
						</div> -->
						<div class="text_item">
							<div class="text_name">简介：</div>
							<!-- <div class="text_info">{{details.content}}</div> -->
							<div class="text_info" v-html="details.content" style="width: calc(100% - 60px);"></div>
							<!-- <rich-text class="text_info" :nodes="details.content" style="width: calc(100% - 40px);"></rich-text> -->
						</div>
					</div>
				</div>
				<div class="video_box">
					<div class="video_title">
						<!-- <div>{{videosrc}}</div> -->
						<div>点播列表</div>
						<!-- <div class="video_icon" @click="allshow = !allshow">
							<div style="font-size: 14px;">{{allshow?'收起':'全部'}}</div>
							<i class="el-icon-caret-bottom" :style="allshow?'transform: rotate(90deg)':''" name="arrow-right" color="#888888" size="14"></i>
						</div> -->
					</div>
					<div v-if="allshow" style="display: flex;align-items: center;flex-wrap: wrap;justify-content: flex-start;">
						<div :class="movid==item.title?'num_active':'num'" v-for="(item,index) in movUrl" @click="changemov(item)" v-html="item.title" ></div>
						<!-- <div :class="movid==item.title?'num_active':'num'" v-for="(item,index) in movUrl" @click="changemov(item)">{{item.title}}</div> -->
						<!-- <div class="num" style="background:#FFF"></div>
						<div class="num" style="background:#FFF"></div>
						<div class="num" style="background:#FFF"></div>
						<div class="num" style="background:#FFF"></div> -->
					</div>
					<scroll-div v-else class="num_list" :scroll-x="true">
						<div style="display: flex;align-items: center;width: max-content;">
							<div :class="movid==item.title?'num_active':'num'" v-for="(item,index) in movUrl" @click="changemov(item)" v-html="item.title"></div>
							<!-- <div :class="movid==item.title?'num_active':'num'" v-for="(item,index) in movUrl" @click="changemov(item)">{{item.title}}</div> -->
						</div>
					</scroll-div>
				</div>
				<!-- <div class="list_box" v-if="movielist.length">
					<div class="list_title">
						<div class="list_color"></div>
						<div>猜你喜欢</div>
					</div>
					<div class="list">
						<div class="list_item" v-for="(item,index) in movielist" @click="bindjump(item)">
							<div class="list_img">
								<image :src="item.imgsrc" mode="scaleToFill" style="width: 100%;height: 220px;border-radius: 5px;"></image>
							</div>
							<div class="list_name">{{item.title}}</div>
						</div>
						<div class="list_item">
							
						</div>
					</div>
				</div> -->
			</div>
		</div>
		<div class="details_right">
			<div class="list_title">
				<div class="list_color"></div>
				<div>相关推荐</div>
			</div>
			<div class="list_box">
				<div class="list_item flex-b" v-for="(item,index) in movielist" :key="index" @click="bindjump(item)">
					<img class="list_img" :src="item.imgsrc" >
					<!-- <div class="video_time">12:10</div> -->
					<div class="list_bottom">
						<div class="list_t1">{{item.title}}</div>
						<div class="list_t2">
							<div style="margin-right: 10px;">{{item.click}}次播放</div>
							<!-- <div>{{item.modifyDt}}</div> -->
						</div>
					</div>
				</div>
			</div>
			
		</div>
	</div>
</template>

<script>
	import { categoryListPage,movieListPage,movieDetails,episodeListPage,addClick } from '@/api/video'
	export default {
		name: 'Details',
	    props: {
			
	    },
	    data() {
	      return {
			  navid:'',
			  title:'',
			detailsshow:false,
			allshow:true,
			form:{
				// time:'', //当前时间戳
				// sign:'',  //签名
				id:'', //电影id
			},
			id:'',
			details:{},
			movUrl:[],
			videosrc:'',
			movid:'',
			listform:{
				// time:'',// 当前时间错
				// sign:'',//  签名
				// category:'',// 分类
				pageNo:2,
				pageSize:20,
			},
			movielist:[],
			id:''
	      }
	    },
	    mounted() {
			this.listform.category = this.$route.query.category
			this.form.id = this.$route.query.id
			this.id = this.$route.query.id
			console.log(this.$route.query.category);
			console.log(this.$route.query.id);
			this.getdetails()
			this.getlist()
			this.getepisodeList()
			this.addClick()
	    },
	    beforeDestroy() {
			
	    },
	    methods: {
			bindsearch(){
				const route = this.$router.resolve({
					path:'/',
					query: { id:e.id,category:this.category}
				})
				window.open(route.href, '_blank')
			},
			getlist(type){
				if(type){
					this.movielist = []
				}
				// this.$delete(this.listform,'sign')
				// this.listform.time = new Date().getTime()
				// this.listform.sign = this.$getsign(this.listform)
				console.log(this.listform,'listform')
				movieListPage(this.listform).then(res=>{
					let arr = []
					arr = res.data.data.list
					arr.forEach((item,index)=>{
						if(item.pic.substr(0,1) == "."){
							item.imgsrc = 'https://www.wzcc.com' + item.pic.slice(1)
						}else{
							item.imgsrc = 'https://www.wzcc.com' +'/'+ item.pic
						}
					})
					// this.movielist = this.movielist.concat(arr)
					this.movielist = arr
				})
				// get_request(getApp().globalData.baseUrl+'/api/gtt/cinema/movieListPage',this.listform, (res) =>{
				// 	// this.total = res.data.total
				// 	let arr = []
				// 	arr = res.data.list
				// 	arr.forEach((item,index)=>{
				// 		if(item.pic.substr(0,1) == "."){
				// 			item.imgsrc = 'https://www.wzcc.com'+ item.pic.slice(1)
				// 		}else{
				// 			item.imgsrc = 'https://www.wzcc.com'+'/'+ item.pic
				// 		}
				// 	})
				// 	this.movielist = arr
				// })
			},
			getdetails(){
				movieDetails(this.form).then(res=>{
					console.log(res,'类型')
				 this.details = res.data.data
				})
				// uni.showLoading({
				// 	title: '加载中'
				// });
				// get_request(getApp().globalData.baseUrl+'/api/gtt/cinema/movieDetails',this.form, (res) =>{
				// 	console.log(res,'details')
				// 	this.details = res.data
				// 	setTimeout(function () {
				// 		uni.hideLoading();
				// 	}, 1000);
				// 	// uni.hideLoading();
				// })
			},
			addClick(){
				addClick({id:this.id}).then(res=>{
					
				})
			},
			getepisodeList(){
				
				episodeListPage({movId:this.id}).then(res=>{
					let arr = []
					arr = res.data.data.list
					arr.forEach((item,index)=>{
						if(item.url.substr(0,1) == "."){
							item.videosrc = 'https://www.wzcc.com' + item.url.slice(1)
						}else{
							item.videosrc = 'https://www.wzcc.com' + item.url
						}
						// item.videosrc = getApp().globalData.baseUrl + item.url.slice(1)
					})
					this.movUrl = arr
					this.movid = arr[0].title
					this.videosrc = arr[0].videosrc
					this.$refs.videoPlayer.play();
				})
			},
			bindjump(e){
				const route = this.$router.resolve({
					path:'/details',
					query: { id:e.id,category:this.listform.category}
				})
				window.open(route.href, '_blank')
				// uni.navigateTo({
				// 	url:'/pages/videodetails/videodetails?id='+e.id+'&category='+this.listform.category
				// })
			},
			changemov(e){
				// uni.showLoading({
				// 	title: '加载中'
				// });
				console.log(e,'点击')
				this.videosrc = ''
				this.movid = e.title
				this.videosrc = e.videosrc
				// setTimeout(function () {
				// 	uni.hideLoading();
				// }, 3000);
			},
			click(item) {
				console.log('item', item);
			},
			getType(){
				categoryListPage().then(res=>{
					console.log(res,'类型')
				  this.list1 = res.data.data.list
				  this.navid = res.data.data.list[0].id
				  this.getlist()
				})
			},
	      
	    }
	}
</script>

<style scoped>
	.details_left{
		width: calc(100% - 430px);
		height: calc(100vh - 40px);
	}
	.details_right{
		width: 380px;
		height: calc(100vh - 40px);
	}
	.text_box{
		margin: 15px;
		font-size: 14px;
		font-weight: 400;
		color: #888888;
		border-bottom: 1px solid #F2F2F2;
	}
	.text_title{
		font-size: 20px;
		font-weight: 600;
		color: #333333;
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 10px;
	}
	.text_t1{
		margin-bottom: 10px;
	}
	.text_item{
		display: flex;
		align-items: center;
		margin: 10px 0;
		line-height: 30px;
		/* justify-content: space-between; */
	}
	.text_name{
		width: 60px;
	}
	.video_box{
		padding: 15px;
	}
	.video_title{
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 14px;
		font-weight: 600;
		color: #333333;
	}
	.video_icon{
		display: flex;
		align-items: center;
		font-size: 26px;
		font-weight: 400;
		color: #888888;
	}
	.num_list{
		/* display: flex;
		align-items: center;
		flex-wrap: nowrap; */
		padding: 15px 0;
		width: 100%;
		border-bottom: 1px solid #F2F2F2;
		/* overflow: scroll; */
	}
	.num,.num_active{
		cursor: pointer;
		margin-right: 15px;
		min-width: 44px;
		height: 44px;
		border-radius: 6px;
		font-size: 16px;
		font-weight: 600;
		margin-top: 15px;
		padding: 0 5px;
	}
	.num{
		background: #F7F7F6;
		color: #666666;
		text-align: center;
		line-height: 44px;
	}
	.num_active{
		background: rgba(244,137,16,0.2);
		color: #F48910;
		text-align: center;
		line-height: 44px;
	}
	.list_title{
		font-size: 18px;
		font-weight: 600;
		color: #333333;
		position: relative;
		height: 20px;
		width: 80px;
		text-align: center;
		margin: 10px 0;
	}
	.list_color{
		width: 80px;
		height: 20px;
		background: linear-gradient(180deg, #FFFFFF 50%, #FFD6A7 100%);
		border-radius: 2px;
		z-index: -1;
		position: absolute;
	}
	
	.search_box{
		width: 400px;
		border: 2px solid #e5e5e5;
		border-radius: 10px;
		height: 40px;
		padding: 0 20px;
		background-color: #FFF;
	}
	.search_text{
		padding: 30px 0 20px;
		font-size: 16px;
		font-weight: 600;
		color: #333;
	}
	.search_text span{
		padding: 0 10px;
		color: #F5A439;
	}
	::v-deep .el-input__inner {
			 border: 1px solid #FFF!important;
	}
	.list_box{
		height: 90vh;
		overflow-y: auto;
		/* padding: 0 20px; */
	}
	.list_item{
		width: 100%;
		height: 80px;
		border-radius: 10px;
		background-color: #FFF;
		/* position: relative; */
		cursor: pointer;
		box-shadow: 0 0 10px 2px rgba(0,0,0,0.1);
		margin-bottom: 20px;
	}
	.list_img{
		width: 100px;
		height: 80px;
		border-radius: 10px 0px 0px 10px;
		/* border: 1px solid red; */
	}

	.list_bottom{
		/* padding: 20px; */
		width: calc(100% - 120px);
		height: 80px;
	}
	.list_t1{
		font-size: 14px;
		color: #333;
		margin: 16px 0 10px;
		/* white-space: nowrap; */
	}
	.list_t2{
		font-size: 12px;
		color: #b4b4b4;
	}
</style>